"use es6";

export function identity(x) {
  return x;
}